import React, { useMemo } from "react";
import PropTypes from "kf-proptypes/widgets";

import { ThemeProvider } from "base/themes";

import { Popover } from "@widgets/feedback/index.jsx";
import { POPOVER_POSITIONS } from "@widgets/feedback/popover/index.jsx";
import { PropertiesField } from "../index.jsx";
import { ColorItem } from "@widgets/inputs/color/palette/item.jsx";
import { toColorVariable } from "@widgets/inputs/color/palette/utils.js";
import { ColorPalettePicker } from "@widgets/inputs/color/index.jsx";
import { SYSTEM_COLOR_TEXTS } from "@widgets/common/constant/index.js";

import styles from "./style.css";

export function ColorPaletteProperty({
  label,
  value,
  modified,
  onReset,
  inheritedFrom,
  showReset,
  showInherit,
  getPanelContainer,
  ...restProps
}) {
  const color = useMemo(
    function generateColorText() {
      const dotRemoved = value && value.split(".");
      return dotRemoved
        .filter((value) => !SYSTEM_COLOR_TEXTS.includes(value))
        .join(" ");
    },
    [value]
  );
  return (
    <ThemeProvider>
      <PropertiesField
        inheritedFrom={inheritedFrom}
        label={label}
        onReset={onReset}
        modified={modified}
        showReset={showReset}
        showInherit={showInherit}
        getPanelContainer={getPanelContainer}
      >
        <Popover
          position={POPOVER_POSITIONS.RIGHT_TOP}
          arrowPointAtCenter={false}
          targetRenderer={() => {
            return (
              <div className={styles.colorinput}>
                <span className={`${styles.value} tiny`}>{color}</span>
                <ColorItem color={toColorVariable(value)} />
              </div>
            );
          }}
        >
          <ColorPalettePicker value={value} colorText={color} {...restProps} />
        </Popover>
      </PropertiesField>
    </ThemeProvider>
  );
}

ColorPaletteProperty.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  modified: PropTypes.bool,
  onReset: PropTypes.func,
  inheritedFrom: PropTypes.string,
  showInherit: PropTypes.bool,
  showReset: PropTypes.bool,
  getPanelContainer: PropTypes.func
};

export * from "./picker.jsx";
